import type { EasyPeasyConfig } from 'easy-peasy';
import { createStore } from 'easy-peasy';

import storeModel from './model';

import { sentryReduxEnhancer } from '~/lib/sentry/sentryReduxEnhancer';

export const storeConfig: EasyPeasyConfig = {
    name: 'smartlearn',
    version: 1,
    enhancers: [sentryReduxEnhancer],
};

export const store = createStore(storeModel, storeConfig);

/**
 * @deprecated Use named import instead
 */
export default store;
